import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

export type BreadcrumbItem = {
    label: string
    href?: string
    cms?: string
}

interface BreadcrumbsProps {
    items: Array<BreadcrumbItem>
    className?: string
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ items, className }): ReactNode => {
    return (
        <nav aria-label='Ruta de navegación' className={cn('text-xs text-muted-foreground', className)}>
            <ol className='flex flex-wrap items-center gap-x-2 gap-y-1'>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1

                    return (
                        <li key={`${item.label}-${index}`} className='flex items-center gap-2'>
                            {item.href && !isLast ? (
                                <Link href={item.href} className='transition-colors hover:text-brass'>
                                    <span data-mdlfy-cms={item.cms}>{item.label}</span>
                                </Link>
                            ) : (
                                <span aria-current={isLast ? 'page' : undefined} className={cn(isLast && 'text-ivory/80')}>
                                    <span data-mdlfy-cms={item.cms}>{item.label}</span>
                                </span>
                            )}

                            {!isLast && <ChevronRight aria-hidden='true' className='size-3.5 text-brass/60' />}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}

export default Breadcrumbs
